import { Component, OnInit, Input, OnChanges, SimpleChange, ViewRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckObjectValuesService } from '../../../value-tracker/_services/check-object-values.service';
import { ManageCaseService } from '../../../value-tracker/_services/manage-case.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalCacheService } from '../../../core/local-cache/local-cache.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-value-header',
  templateUrl: './value-header.component.html'
})
export class ValueHeaderComponent implements OnInit, OnChanges {
  @Input() stage = 0;
  @Input() showValueHeader: boolean;
  @Input() processStatusData: any;
  caseId: string;
  customerName: String = '';
  customerSiteLocation: String = '';
  translatedText = [];
  disableValueHeader = false;
  sourceOfRedirection: any = {
    'fromPage': '',
    'caseId': 0,
    'caseStatus': ''
  };
  private steps: Array<any> = [
    {
      text: 'Create Case',
      name: 'isCaseCreationCompleted',
      url: 'evaluator/case',
      className: ''
    },
    {
      text: 'Performance Gaps',
      name: 'isPerformanceGapSelectionCompleted',
      url: '/performancegaps',
      className: ''
    },
    {
      text: 'Customer Performance Gaps',
      name: 'isCustomerPerformaceGapsCompleted',
      url: '/customerperformancegaps',
      className: ''
    },
    {
      text: 'Documents & Comments',
      name: 'isDocumentsAndCommentsCompleted',
      url: '/misc',
      className: '/customerperformancegapvalue'
    },
    {
      text: 'Opportunity Value',
      name: 'isCalculatedGapValueCompleted',
      url: '',
      className: ''
    }
  ];
  constructor(private router: Router,
    private cdr: ChangeDetectorRef,
    private checkObjectValuesService: CheckObjectValuesService,
    private manageCaseService: ManageCaseService,
    private route: ActivatedRoute,
    private storage: LocalCacheService,
    private translate: TranslateService) {
    translate.get([
      'HEADER.CREATE_CASE',
      'HEADER.PERFORMANCE_GAPS',
      'HEADER.CUSTOMER_PERFORMANCE_GAPS',
      'HEADER.DOCUMENTS_AND_COMMENTS',
      'HEADER.OPPORTUNITY_VALUE'
    ]).subscribe((translations: string) => {
      this.translatedText[0] = translations['HEADER.CREATE_CASE'];
      this.translatedText[1] = translations['HEADER.PERFORMANCE_GAPS'];
      this.translatedText[2] = translations['HEADER.CUSTOMER_PERFORMANCE_GAPS'];
      this.translatedText[3] = translations['HEADER.DOCUMENTS_AND_COMMENTS'];
      this.translatedText[4] = translations['HEADER.OPPORTUNITY_VALUE'];
    });
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.stage !== undefined && changes.stage.currentValue &&
      changes.stage.currentValue !== undefined && !changes.stage.currentValue.firstChange) {
      this.stage = changes.stage.currentValue;
      this.fetchCustomerSiteDetails();
      this.updateStage();
    }
    // tslint:disable-next-line: max-line-length
    if (changes.showValueHeader !== undefined && changes.showValueHeader.currentValue !== undefined && !changes.showValueHeader.currentValue.firstChange) {
      this.showValueHeader = changes.showValueHeader.currentValue;
      if (!this.showValueHeader) {
        for (let i = 0; i < this.steps.length; i++) {
          this.steps[i].className = '';
        }
      } else {
        this.updateStage();
      }
    }
    if (isNullOrUndefined(changes.stage)) {
      this.updateStage();
    }
    this.detectChangeReady();
  }

  ngOnInit() {
  }
  updateStage() {
    // console.log(this.processStatusData);
    this.caseId = this.router.url.split('evaluator/case/').pop().split('/')[0];
    if (this.caseId === null || this.caseId === '') {
      this.storage.clearData('sourceOfEditCase', 'session');
    }
    this.sourceOfRedirection = JSON.parse(this.storage.fetchData('sourceOfEditCase', 'session'));
    if (!isNullOrUndefined(this.sourceOfRedirection)) {
      this.disableValueHeader = this.sourceOfRedirection.caseStatus === 'Pending' ? true : false;
    }
    for (let i = 0; i < this.steps.length; i++) {
      if (this.processStatusData[this.steps[i].name] === true && this.stage !== i + 1) {
        this.steps[i].className = 'active complete';
      } else if (this.router.url.includes(this.steps[i].url) && this.stage === i + 1) {
        this.steps[i].className = 'active';
      } else {
        this.steps[i].className = '';
      }
    }
    // const count = this.steps.length;
    // if (this.stage) {
    //   for (let i = 0; i < this.stage; i++) {
    //     if ((i + 1) === this.stage) {
    //       this.steps[i].className = 'active';
    //     } else if (this.stage !== 1) {
    //       this.steps[i].className = 'active complete';
    //     }
    //   }
    //   for (let j = this.stage; j < count; j++) {
    //     this.steps[j].className = '';
    //   }
    // }
  }

  navigateToStep(eventData) {
    // console.log(eventData);
    switch (eventData) {
      case 'Create Case':
        eventData = 'siteSelection';
        break;
      case 'Performance Gaps':
        eventData = 'performancegaps';
        break;
      case 'Customer Performance Gaps':
        eventData = 'customerperformancegaps';
        break;
      case 'Documents & Comments':
        eventData = 'misc';
        break;
      case 'Opportunity Value':
        eventData = 'customerperformancegapvalue';
        break;

    }
    this.checkObjectValuesService.navigationWithValueHeader(eventData);
  }

  fetchCustomerSiteDetails() {
    this.caseId = this.router.url.split('evaluator/case/').pop().split('/')[0];
    if (this.stage > 1 && this.customerSiteLocation === '' && this.caseId !== undefined && this.caseId !== null && this.caseId !== '') {
      this.manageCaseService.getCustomerSiteName(this.caseId).subscribe(response => {
        if (response.status === 200) {
          const customerData = response.result;
          this.customerName = customerData.customerName;
          this.customerSiteLocation = ' - ' + customerData.siteName;
        }
      });
    } else if (this.stage <= 1) {
      this.customerSiteLocation = '';
    }
  }

  detectChangeReady() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/value-header/value-header.component.ts